// src/main.js
import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "@/layouts/appLayout.vue";
import router from "@/router";
import i18n from '@/langs/i18n';
import Vue3Toastify from "vue3-toastify";
import "vue3-toastify/dist/index.css";

const app = createApp(App);
app.use(router);

// pinia antes de qualquer coisa que use stores
const pinia = createPinia();
app.use(pinia);

// plugins
app.use(Vue3Toastify, {
  position: 'bottom-right',
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progressClassName: 'progress-bar-custom',
});
app.use(i18n);

// global error handler
app.config.errorHandler = (err, instance, info) => {
  console.error('[GlobalError]', err, info);
  app.config.globalProperties.$toast?.error('Ocorreu um erro interno.');
};

app.mount("#app");

// Registrar SW apenas em produção e após load
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(reg => console.log('Service Worker registrado', reg.scope))
      .catch(err => console.warn('Falha ao registrar SW:', err));
  });
}
